import {images} from "../../../assets/images";

export const AlignObjectPosition = () => {
  return `
    <div class="align-tools">
        <label class="align-position-label">Align Position: </label>
        <label for="positionTop" class="position-label-wrapper">
          <img src=${images.position_top} alt="topLogo" width="28" height="24"/>
          <p>Top</p>
          <input id="positionTop" type="button" class="align-tools-toolBtn" value="Top" />
        </label>

        <label for="positionBottom" class="position-label-wrapper">
          <img src=${images.position_bottom} alt="topLogo" width="28" height="24"/>
          <p>Bottom</p>
          <input id="positionBottom" type="button" class="align-tools-toolBtn" value="Bottom" />
        </label>

        <label for="positionLeft" class="position-label-wrapper">
          <img src=${images.position_left} alt="topLogo" width="28" height="24"/>
          <p>Left</p>
          <input id="positionLeft" type="button" class="align-tools-toolBtn" value="Left" />
        </label>

        <label for="positionRight" class="position-label-wrapper">
          <img src=${images.position_right} alt="topLogo" width="28" height="24"/>
          <p>Right</p>
          <input id="positionRight" type="button" class="align-tools-toolBtn" value="Right" />
        </label>

        <label for="positionCenter" class="position-label-wrapper">
          <img src=${images.position_center} alt="topLogo" width="28" height="24"/>
          <p>Center</p>
          <input id="positionCenter" type="button" class="align-tools-toolBtn" value="Center" />
        </label> 
    </div>
    `;
};
